module.exports = __webpack_public_path__ + "static/media/phonetour.c0050853.svg";